import {
  FETCH_UNREAD_NOTIFICATIONS_SUCCESS,
  FETCH_DISMISSED_NOTIFICATIONS_SUCCESS,
  FETCH_LATEST_NOTIFICATIONS_SUCCESS,
  FETCH_UNREAD_STATUS_SUCCESS,
  MARK_ALL_SEEN_SUCCESS
} from './constants'

const initialState = {
  unread: {
    entries: [],
    unseenCount: 0,
    pagination: {
      page: 1,
      perPage: 10,
      total: 0
    }
  },
  dismissed: {
    entries: [],
    unseenCount: 0,
    pagination: {
      page: 1,
      perPage: 10,
      total: 0
    }
  },
  latest: {
    entries: []
  },
  unreadStatus: {
    has_unread: false
  }
}

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case FETCH_UNREAD_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        unread: {
          ...state.unread,
          entries: payload.entries.entries,
          unseenCount: payload.unseen_count,
          pagination: payload.entries.pagination
        }
      }
    case FETCH_DISMISSED_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        dismissed: {
          ...state.unread,
          entries: payload.entries.entries,
          unseenCount: payload.unseen_count,
          pagination: payload.entries.pagination
        }
      }
    case FETCH_LATEST_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        latest: payload
      }
    case FETCH_UNREAD_STATUS_SUCCESS:
      return {
        ...state,
        unreadStatus: payload
      }
    case MARK_ALL_SEEN_SUCCESS:
      return state
    default:
      return state
  }
}
